// VIDEO PLAYER
document.addEventListener("DOMContentLoaded", (event) => {    

    const MyfVideo = document.getElementsByClassName('__MyfVideo');

    Array.prototype.forEach.call(MyfVideo, function(CurrentWrapper) {
        let CurrentVideo = CurrentWrapper.querySelector('video');
        let ButtonId = CurrentVideo.getAttribute('data-videoid');
        let Button = document.getElementById(ButtonId);
        Button.addEventListener('click', function() {
            if (CurrentVideo.paused) {
                CurrentVideo.play();
                Button.querySelector('svg').style.opacity = 0;
            } else {
                CurrentVideo.pause();
                Button.querySelector('svg').style.opacity = 1;
            }
        });
    });

});
      